import { useMemo, useState } from "react";
import Divider from "../../../../../../../../components/Divider/Divider";
import FlexColumn from "../../../../../../../../components/FlexBox/FlexColumn";
import FlexRow from "../../../../../../../../components/FlexBox/FlexRow";
import SButton from "../../../../../../../../components/SButton/SButton";
import Typography from "../../../../../../../../components/Typography/Typography";
import { colors } from "../../../../../../../../styles/colors";
import Door from "./Door";
import { credsTypesMap } from "../../../../../../../../utils/Common";
import { useDispatch } from "react-redux";
import { doAddControllerDoors, doCreateOrganisationController } from "../../../../../../../../redux/thunks/organisation";
import styles from '../../styles.module.scss'

const AddDoors = ({ readerPortStatus = [], downstreamBoardStatus = [], accessPoint, partnerId, customerId, onSuccess, editModeChannelOptions, editMode = false }) => {
    const dispatch = useDispatch();
    const [doorsCount, setDoorCounts] = useState(0);

    const [doors, setDoors] = useState({});
    const [channelsMap, setChannelsMap] = useState({});
    const [inProgress, setInProgress] = useState(false);

    const hAddDoor = () => {
        setDoors(prev => ({
            ...prev,
            [doorsCount + 1]: {
                id: doorsCount + 1,
                accessPointName: '',
                configuration: {
                    name: '',
                    value: '',
                    formOptions: {
                        entry: false,
                        exit: false,
                        control: false,
                        lockingMechanism: false,
                        relayTime: false,
                        attendanceAvailable: false,
                        doorSensor: false,
                    },
                    skipSerialValidations: false,
                    validSerials: {
                        entry: [],
                        exit: [],
                        control: [],
                    },
                    lockingMech: {},
                },
                entryDeviceSerialNum: {
                    value: '',
                    description: '',
                    error: '',
                    channel: '',
                    channelError: '',
                    genericReader: false,
                },
                exitDeviceSerialNum: {
                    value: '',
                    description: '',
                    error: '',
                    channel: '',
                    channelError: '',
                    genericReader: false,
                },
                credTypes: [],
                checkedCredTypes: { ...credsTypesMap },
                supportedAccessType: 0,
                credentialNotSupported: false,
                commonCredentials: '',
                checkedCommonCred: { ...credsTypesMap, count: 0 },
                inProgress: true,
                lockingMech: {
                    name: '',
                    value: '',
                    relayTime: '',
                },
                relayTime: 0,
                inveteredRelayLogic: false,
                attendanceEnabled: false,
                relayTimeError: '',
                toggleRelaytime: true,
                doorSensorEnabled: false,
                normallyOpen: true,
                opened: true,
            }
        }))
        setDoorCounts(prev => (prev + 1))
    }

    function bitMapCreds(data) {
        const keys = Object?.keys(credsTypesMap);

        const bitMap = [];

        keys.forEach((key, index) => {
            if (data[key]) {
                if (key === "mobile_ble") {
                    bitMap.push(1, 1, 1);
                } else {
                    bitMap.push(1);
                }
            } else {
                if (key === "mobile_ble") {
                    bitMap.push(0, 0, 0);
                } else {
                    bitMap.push(0);
                }
            }
        });

        return parseInt(bitMap?.reverse()?.join(''), 2);
    }

    const hDisable = useMemo(() => {
        if (Object?.keys(doors)?.length <= 0) {
            return true;
        }

        if (Object?.values(channelsMap)?.find(cm => cm?.length > 1)) {
            return true;
        }

        const allDoors = Object.values(doors) || [];

        for (let i = 0; i < allDoors?.length; i++) {
            const selectedDoor = allDoors[i];

            if (selectedDoor?.inProgress || !selectedDoor?.accessPointName?.trim()) {
                return true;
            }
            if (selectedDoor?.configuration?.formOptions?.entry &&
                (!selectedDoor?.configuration?.value ||
                    !selectedDoor?.entryDeviceSerialNum?.channel ||
                    !(selectedDoor?.entryDeviceSerialNum?.genericReader || selectedDoor?.entryDeviceSerialNum?.value) ||
                    selectedDoor?.entryDeviceSerialNum?.error)
            ) {
                return true;
            }

            if (selectedDoor?.configuration?.formOptions?.exit &&
                (!selectedDoor?.exitDeviceSerialNum?.channel ||
                    !(selectedDoor?.exitDeviceSerialNum?.genericReader || selectedDoor?.exitDeviceSerialNum?.value) ||
                    selectedDoor?.exitDeviceSerialNum?.error)
            ) {
                return true;
            }

            if (!(selectedDoor?.entryDeviceSerialNum?.genericReader || selectedDoor?.exitDeviceSerialNum?.genericReader) && selectedDoor?.configuration?.formOptions?.exit &&
                selectedDoor?.entryDeviceSerialNum?.value?.substring(0, 4) !== selectedDoor?.exitDeviceSerialNum?.value?.substring(0, 4)) {
                return true;
            }

            if (selectedDoor?.configuration?.formOptions?.exit && selectedDoor?.entryDeviceSerialNum?.value && selectedDoor?.entryDeviceSerialNum?.value === selectedDoor?.exitDeviceSerialNum?.value) {
                return true;
            }

            if (!selectedDoor?.lockingMech?.value || selectedDoor?.relayTimeError) {
                return true;
            }
        }
        return false
    }, [doors, channelsMap]);

    const handleSave = () => {
        setInProgress(true);

        const payload = Object?.values(doors)?.map(d => {
            const toAdd = {
                name: d?.accessPointName,
                configuration: d?.configuration?.value,
                "enableAttendance": d?.attendanceEnabled,
                "isControllerAttached": true,
                "controllerType": Number(accessPoint?.controllerType),//AZURE CONTROLLER TYPE
                "doorSensorSettings": {
                    "doorSensorEnable": d?.doorSensorEnable,
                    "doorSensorType": d?.normallyOpen ? 1 : 2
                },
                "wireProtocol": Number(accessPoint?.wireProtocol),
                "devices": [],
                "lockingMechanism": d?.lockingMech?.value,
                "relaySettings": {
                    "relayOnTime": Number(d?.relayTime),
                    "invertRelayLogic": d?.inveteredRelayLogic
                },
                "credentials": {
                    supportedAccessType: d?.supportedAccessType,
                    enabledAccessType: bitMapCreds(d?.checkedCredTypes)
                }
            }
            if (d?.configuration?.formOptions?.entry) {
                let comPort = -1;
                let readerPort = 1;
                const split = d?.entryDeviceSerialNum?.channel?.split("-");
                if (d?.entryDeviceSerialNum?.channel?.includes("Downstream Board")) {
                    const port = Number(split?.[0]?.slice(16));
                    comPort = port;
                }
                readerPort = Number(split?.[1]?.replace("R", ""))
                toAdd['devices']?.push({
                    "serialNumber": d?.entryDeviceSerialNum?.value,
                    "deviceType": 1,
                    "comPort": comPort,
                    "readerPortNumber": readerPort,
                })
            }

            if (d?.configuration?.formOptions?.exit) {
                let comPort = -1;
                let readerPort = 1;
                const split = d?.exitDeviceSerialNum?.channel?.split("-");
                if (d?.exitDeviceSerialNum?.channel?.includes("Downstream Board")) {
                    const port = Number(split?.[0]?.slice(16));
                    comPort = port;
                }
                readerPort = Number(split?.[1]?.replace("R", ""))

                toAdd['devices']?.push({
                    "serialNumber": d?.exitDeviceSerialNum?.value,
                    "deviceType": 2,
                    "comPort": comPort,
                    "readerPortNumber": readerPort,
                })
            }

            toAdd['devices']?.push({
                "serialNumber": accessPoint?.controllerDeviceSerialNum?.vendorToSpintlySerialNum || accessPoint?.controllerDeviceSerialNum?.value,
                "deviceType": accessPoint?.controllerType === '1' ? 3 : accessPoint?.controllerType === '6' ? 6 : 4,//LOGIC NEEDS TO BE CHANGED as per satnil controller type 1 is spintly its sent as 3 because its 1 DC and 4 is sent because its Multichannel (azure and Istar)
                "comPort": -1,
                "readerPortNumber": 0
            })

            return toAdd;
        })

        dispatch(doAddControllerDoors({
            partnerId,
            networkId: accessPoint?.network?.id,
            organisationId: customerId,
            payload: payload,
            callback: () => {
                onSuccess(payload?.map(d => d?.name))
            },
            onFinally: () => {
                setInProgress(false);
            },
            getDoorsList: !editMode
        }))
    }

    return (
        <FlexColumn>
            <FlexColumn flexWrap="nowrap" styles={{ marginBottom: '4rem' }}>
                <FlexColumn gap="0.1rem">
                    <FlexRow flexWrap="nowrap">
                        <FlexColumn gap="0.2rem" alignItems="start">
                            <Typography variant="h7SB">Create Door</Typography>
                            <Typography variant="b2R" color={colors.grey400}>Create doors by selecting channels and adding readers</Typography>
                        </FlexColumn>
                        <SButton variant={"secondary"} minWidth onClick={hAddDoor}>
                            Add Doors
                        </SButton>
                    </FlexRow>
                    <Divider />
                </FlexColumn>
                {[...readerPortStatus, ...downstreamBoardStatus]?.map((b, i) => {

                    return <FlexColumn alignItems="start" gap={"0.5rem"} styles={{ background: colors.grey025, padding: '1rem', borderRadius: '0.5rem' }}>
                        <Typography variant="b1SB">Door {i + 1}</Typography>
                        <FlexRow justifyContent="start">
                            <Typography variant="b3R" color={colors.grey400}> Serial Number : {b?.readerSerialNumber}</Typography>
                            <Typography variant="b3R" color={colors.grey400}> Reader Channel : {b?.comPort ? `Downstream Board ${b?.comPort}` : 'Main Board'} - R{b?.readerPortNumber}</Typography>
                        </FlexRow>
                    </FlexColumn>
                })}
                {Object.values(doors)?.map((d, i) => <Door doorCount={(readerPortStatus?.length + downstreamBoardStatus?.length) + (i + 1)} accessPointDetails={accessPoint} allDoors={doors} ap={d} setDoors={setDoors} channelsMap={channelsMap} setChannelsMap={setChannelsMap} editModeChannelOptions={editModeChannelOptions} />)}

            </FlexColumn>
            <FlexRow justifyContent="end" className={styles["fixed-actions"]}>
                {/* <SButton color={"grey"} minWidth onClick={() => { }}>Back</SButton> */}
                <SButton
                    disabled={hDisable || inProgress}
                    minWidth
                    onClick={handleSave}>Save</SButton>
            </FlexRow>

        </FlexColumn>
    )
}

export default AddDoors;